import React, { FC, FormEvent, useEffect, useState } from 'react';
// import { useRouter } from 'next/router';
import { logger } from '@marriott/shared/mi-helper-utils';

import clsx from 'clsx';
import { Heading, CheckBox, Button, Link, headingType, Types } from '@marriott/mi-ui-library';
import { AuthStateEnum } from '@marriott/shared/mi-helper-utils';
import { FullWidthContainer, StyledSignInForm, WrapText, StyledInputTextField } from './SignInForm.styles';
import { SignInFormProps, ErrorMessageKeys } from './SignInForm.types';
// Step 1 ; fetching userdetail store
import { getUserDetails, useUserDetailsGlobalStore } from '@marriott/mi-store-utils';
import { LOGIN_URL, MFA_OPTIONS_KEY, SHOW_BROWSER_REGISTRATION } from '../../util/constants';

import { encryptPassword, updatePublicKey } from '../../util/helpers';
import { usePathname } from 'next/navigation';
import { useCreateSurveyStore } from '../../store/createSurveyStore';
const { log } = logger({})('SignInForm');

export const SignInForm: FC<SignInFormProps> = props => {
  const {
    // loginPasswordPlaceHolder,
    // clearRememberedAccountLabel,
    // clearRememberedAccountUrl,
    welcomeText,
    signInErrorMessages,
    ariaLabelId,
    onClose,
    modalData,
    isOpen,
  } = props;
  const { formData, setFormData } = useCreateSurveyStore(); // Access formData? from Zustand store
  // const router = useRouter();
  const { ATTEMPTED_SIGNIN } = AuthStateEnum;

  // Step 2 : we are fetching the userdata
  const { userProfileData, isRememberedUser } = useUserDetailsGlobalStore(state => ({
    userProfileData: state,
    isRememberedUser: state.rememberedUser,
  }));

  const [username, setUsername] = useState<string>(userProfileData?.memberNumber || '');
  const [password, setPassword] = useState<string>('');
  const [validUserName, setValidUserName] = useState<boolean>(true);
  const [validPassword, setValidPassword] = useState<boolean>(true);
  const [passwordType, setPasswordType] = useState<'text' | 'password'>('password');
  const [checked, setChecked] = useState<boolean>(true);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [publicKey, setPublicKey] = useState('');
  const signinFormHeading = modalData?.signinFormHeading ?? 'Sign in to your account';
  const emailNumberText = 'Email or Member Number';
  const passswordText = modalData?.passswordText ?? 'Password';
  const rememberMeText = modalData?.rememberMeText ?? 'Remember me';
  const signinText = modalData?.signinText ?? 'Sign In';
  const forgotPasswordText = modalData?.forgotPasswordText ?? 'Forgot password';
  const forgotPasswordTextLink = modalData?.forgotPasswordLink ?? '/forgotPassword.mi';
  const activateAccountText = modalData?.activateAccountText ?? 'Activate online account';
  const activateAccountLink = modalData?.activateAccountLink ?? '/loyalty/createAccount/activateAccountChallenge.mi';
  // Match for the following:
  // * Remembered me userid, a string with exactly 4 digits followed by one or more asterisks: \d{4}\*+
  // * Straight-up userid, a string with at least 6 digits: \d{6,}
  // * 3 groups of 3 digits: \d{3} \d{3} \d{3}
  // * An email address: [\w.+-]+@[\w-]+\.[\w.-]+
  const usernamePattern = /^(?:\d{3}\*+|\d{6,}|\d{3} \d{3} \d{3}|[\w.+-]+@[\w-]+\.[\w.-]+)$/;

  const [signInErrors, setSignInErrors] = useState<ErrorMessageKeys[]>();
  const enableEncryption = 'true';
  // const isSubmitDisabled = !validPassword || !validUserName || isSubmitting;
  console.log(isSubmitting);
  // not required for now

  const SignInfetchUserDetails = async () => {
    getUserDetails(true);
  };

  const pathName = usePathname();

  useEffect(() => {
    updatePublicKey(setPublicKey);
  }, []);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();

    if (!password.length || !username.length) {
      setValidPassword(password.length >= 1);
      setValidUserName(username.length >= 1);
      return;
    }
    if (password.length && username.length) {
      setIsLoading(true);
    }
    setIsSubmitting(true);

    try {
      // first we are encrypting password - step 1 - working
      const encryptedPassword = encryptPassword(password, publicKey, enableEncryption);
      let fullUrl = window.location.href;

      if (formData?.isSubmitDataFlow) {
        const protocol = window.location.protocol;
        const host = window.location.host;
        fullUrl = `${protocol}//${host}/my/prearrival/thank-you.mi?marshaCode=${formData?.marshaCode}&confirmationNumber=${formData?.confirmationNumber}`;
      }

      const signInData = {
        // TODO: Once the return url and sign-in url ara available from model add those variables to value attribrute
        pageModuleName: 'Sign In',
        password: encryptedPassword,
        rememberMe: checked,
        returnUrl: fullUrl,
        userId: username,
      };
      const response = await fetch(LOGIN_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(signInData),
      });

      const data = await response.json();

      const isMFA = data?.mfaOption && (data?.mfaOption?.emailAddress || data?.mfaOption?.phoneNumbers?.length > 0);

      // if (data?.customerDetails) {

      // }
      if (pathName.includes('review')) {
        setFormData({ ...formData, isUserLoggedInReviewPage: true });
      }
      // data.status will give - SUCESS/FAILURE
      if (data.status !== 'SUCCESS') {
        const errorMessages = data?.phoenixErrorMessages?.errorMessages as ErrorMessageKeys[];
        // check if error is present in error object
        const isErrorLabelPresent = errorMessages?.some(errorMssg => !!signInErrorMessages?.[errorMssg]);
        if (isErrorLabelPresent) {
          setSignInErrors(errorMessages);
        } else {
          setSignInErrors(['uxlFailureErrorMessage']);
        }
        // Reset submitting/loading state so the user can try again
        setIsSubmitting(false); // requirement: stop "form submitting" state (e.g., disable submit button)
        setIsLoading(false); // requirement: stop global loading indicator/spinner
        if (data?.nextStateURI) {
          window.location.href = data?.nextStateURI;
        }
      } else if (isMFA) {
        window.sessionStorage.setItem(MFA_OPTIONS_KEY, JSON.stringify(data.mfaOption));
        window.sessionStorage.setItem(SHOW_BROWSER_REGISTRATION, JSON.stringify(data?.showBrowserRegistrationCta));
        window.sessionStorage.setItem('BROWSERCONF', JSON.stringify(formData?.confirmationNumber));

        if (formData?.isReviewPageFlow) {
          setFormData({
            ...formData,
            isUserEnableSignIn: false,
            isRememberUser: false,
            isSignInDrawerOpen: false,
            isMFAActive: true,
          });
          window.location.href = data?.nextStateURI;
        } else {
          setFormData({ ...formData, isUserEnableSignIn: true, isRememberUser: false, isSignInDrawerOpen: false });
          if (data?.nextStateURI && !formData?.isReviewPageFlow) {
            window.location.href = data?.nextStateURI;
          }
        }
      } else {
        SignInfetchUserDetails();

        if (formData?.isReviewPageFlow) {
          setFormData({ ...formData, isUserEnableSignIn: true, isRememberUser: false, isSignInDrawerOpen: false });
        } else {
          setFormData({ ...formData, isUserEnableSignIn: true, isRememberUser: false, isSignInDrawerOpen: false });
          if (data?.nextStateURI && !formData?.isReviewPageFlow) {
            window.location.href = data?.nextStateURI;
          }
        }
        onClose?.();
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
      log.error(error);
      setIsSubmitting(false);
      setSignInErrors(['uxlFailureErrorMessage']);
      setIsLoading(false);
      setFormData({ ...formData, isSubmitDataFlow: false });
    } finally {
      localStorage.setItem(ATTEMPTED_SIGNIN, 'true');
    }
  };

  // const clearRememberedUser = async () => {
  //   try {
  //     const response = await fetch(clearRememberedAccountUrl);
  //     const { nextStateURI } = await response.json();
  //     if (nextStateURI) {
  //       window.location.href = nextStateURI;
  //     } else {
  //       window.location.reload();
  //     }
  //   } catch (e) {
  //     log.error('Something went wrong clearing remembered user', e);
  //     window.location.reload();
  //   }
  // };
  /** Reset all form values & errors */
  const resetForm = () => {
    setUsername(userProfileData?.memberNumber || '');
    setPassword('');
    setValidUserName(true);
    setValidPassword(true);
    setPasswordType('password');
    setChecked(true);
    setIsSubmitting(false);
    setIsLoading(false);
    setSignInErrors(undefined);
  };
  useEffect(() => {
    if (isOpen) {
      resetForm();
    }
  }, [isOpen]);
  return (
    <StyledSignInForm onSubmit={handleSubmit} className="d-flex flex-column align-items-start ">
      <Heading
        variation={headingType.title}
        titleText={
          isRememberedUser ? `${welcomeText} ${userProfileData?.headerSubtext?.consumerName}` : signinFormHeading
        }
        customClass={clsx(' t-title-s', isRememberedUser ? 'welcomeText mt-5' : 'mt-4 pb-2', ' mt-lg-5 mb-0')}
        id={ariaLabelId}
      />
      {isRememberedUser && (
        <div>
          <Heading variation={headingType.subtitle} titleText={signinText} customClass={'subHeading t-label-s mb-3'} />
        </div>
      )}
      {/* TODO: Once the return and sign-in url ara available from model add those variables to value attribrute */}
      <input type="hidden" className="sign-in-return-url" name="returnUrl" value="/default.mi" />
      <input type="hidden" name="errorUrl" value="/sign-in-error.mi" />
      {signInErrors &&
        signInErrors.map(
          errorMessageKey =>
            signInErrorMessages[errorMessageKey] && (
              <FullWidthContainer>
                <div className="m-message-inline error-sev1" data-testid="error-message">
                  <div className="m-message-content-wrap">
                    <WrapText dangerouslySetInnerHTML={{ __html: signInErrorMessages[errorMessageKey] as string }} />
                  </div>
                </div>
              </FullWidthContainer>
            )
        )}
      <StyledInputTextField
        type={'text'}
        testId={'signinusername'}
        label={emailNumberText}
        inputValue={isRememberedUser ? userProfileData?.memberNumber : username}
        showErrorMessage={!validUserName}
        className={` m-input-field ${!isRememberedUser && validUserName && username?.length > 0 ? 'is-active' : ''}${
          isRememberedUser ? 'is-disabled' : ''
        } align-self-stretch mt-3 mt-lg-4 pb-2`}
        messageToShow={username || userProfileData?.memberNumber ? '' : signInErrorMessages.errorForUserName}
        messageClass="mx-3 d-block"
        getInputValue={(val: string) => {
          setUsername(val);
          setValidUserName(usernamePattern.test(val));
        }}
        getInputProps={() => {
          return isRememberedUser ? { disabled: true } : {};
        }}
      />
      <StyledInputTextField
        type={passwordType}
        testId={'signinpassword'}
        label={passswordText}
        inputValue={password}
        className={`m-input-field ${password?.length > 0 ? 'is-active' : ''} align-self-stretch mt-4 mt-lg-5`}
        messageClass="errorMessage mx-3 d-block"
        getInputValue={val => {
          setPassword(val);
          setValidPassword(val?.length >= 1);
        }}
        iconOnClick={() => {
          if (passwordType === 'password') {
            setPasswordType('text');
          } else setPasswordType('password');
        }}
        iconClass={`icon icon-visibility${passwordType !== 'password' ? '' : '-off'}`}
        showIcon={!!password?.length}
        showErrorMessage={!validPassword}
        messageToShow={signInErrorMessages.errorForPassword}
      />
      <input type="hidden" name="errorUrl" value="/sign-in-error.mi" />
      <CheckBox
        checkboxId={'signincheckbox'}
        checked={checked}
        onChange={() => setChecked(!checked)}
        checkboxLabel={rememberMeText}
        checkboxName="signincheckbox"
        className="checkBoxLabel mt-4 mt-lg-5"
      />
      <Button
        type={Types.ButtonTypeVariation.Submit}
        testId="sign-in-btn-submit"
        // isDisabled={isSubmitDisabled}
        className={clsx('m-button-m signInButton mt-4 mt-lg-5')}
        ariaLabel={signinText}
      >
        <div className={clsx(!isLoading ? 'd-none' : 'm-spinner-s')} data-testid="loading-spinner"></div>
        <div className={clsx(isLoading ? 'd-none' : '')}>{props?.signInLabel}</div>
      </Button>

      <div className="d-flex flex-column align-items-start mt-4 links-wrapper">
        <Link
          text={forgotPasswordText}
          linkClassName={'m-link-action linkClass signIn-container'}
          linkHref={forgotPasswordTextLink}
          id="forgotpassword"
          target="_self"
        />
        {/* {isRememberedUser ? (
          <StyledLinkButton
            className="m-link-action linkClass  clearRememberedBtn"
            callback={clearRememberedUser}
            id="clearrememberedaccount"
            buttonCopy={clearRememberedAccountLabel}
          />
        ) : ( */}
        <Link
          text={activateAccountText}
          linkClassName="m-link-action linkClass signIn-container "
          linkHref={activateAccountLink}
          id="activateonlineaccount"
          target="_self"
        />
        {/* )} */}
      </div>
    </StyledSignInForm>
  );
};
